import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { GeneratedPage } from './pages/GeneratedPage';
import { InboxPage } from './pages/InboxPage';
import { ApiDocsPage } from './pages/ApiDocsPage';
import EmailClientPage from './pages/EmailClientPage';
import { Navbar } from './components/Navbar';
import './styles/layout.css';

export default function App() {
  return (
    <Router>
      <div className="stone-wrapper">
        <Navbar />
        <main className="stone-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/generated" element={<GeneratedPage />} />
            <Route path="/inbox/:email" element={<InboxPage />} />
            <Route path="/api-docs" element={<ApiDocsPage />} />
            <Route path="/email-client" element={<EmailClientPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}
